import React, { useEffect, useState } from 'react';
import Card1 from '../components/Card1';
import Card2 from '../components/Card2';
import Card3 from '../components/Card3';
import Card4 from '../components/Card4';
import Card5 from '../components/Card5';
import Card6 from '../components/Card6';
import Chart1 from '../components/Chart1';
import Chart2 from '../components/Chart2';
import Chart3 from '../components/Chart3';

import Tables from '../components/Tables';

import ApiService from '../services/ApiService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Dashboard() {

  // Loading general
  const [loading, setLoading] = useState(true);

  // Data individual del dashboard
  const [registeredUsers, setRegisteredUsers] = useState(null);            // usuariosRegistrados[0].total_jugadores
  const [survivorsAll, setSurvivorsAll] = useState([]);                    // survivorsAll[]
  const [survivorsEnRegistro, setSurvivorsEnRegistro] = useState(null);    // survivorsEnRegistro[0].survivors_en_registro
  const [survivorsActivos, setSurvivorsActivos] = useState(null);          // survivorsActivos[0].survivors_activos
  const [usuariosVivos, setUsuariosVivos] = useState(null);                // usuariosVivos[0].jugadores_vivos
  const [totalJugadores, setTotalJugadores] = useState([]);                // totalJugadores[]
  const [survivorsInfo, setSurvivorsInfo] = useState([]);                  // survivorsInfo[]
  const [survivorsFinalizados, setSurvivorsFinalizados] = useState(null);  // survivorsFinalizados[0].survivors_finalizados
  const [seleccionesHechas, setSeleccionesHechas] = useState(null);        // seleccionesHechas[0].selecciones_hechas
  const [top3Equipos, setTop3Equipos] = useState([]);                       // top3Equipos[]

  const checkAndSet = (data, setter, key) => {
    if (Array.isArray(data) && data.length > 0) {
      // Si key está definido, extrae esa propiedad del primer elemento
      if (key) {
        setter(data[0][key]);
      } else {
        // Si no hay key, asume que el array completo es el dato
        setter(data);
      }
    } else {
      setter('empty');
    }
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        const res = await ApiService.get('/survivor/dashboard');

        if (res) {
          checkAndSet(res.usuariosRegistrados, setRegisteredUsers, 'total_jugadores');
          checkAndSet(res.survivorsAll, setSurvivorsAll);
          checkAndSet(res.top3Equipos, setTop3Equipos);
          checkAndSet(res.usuariosVivos, setUsuariosVivos, 'jugadores_vivos');
          checkAndSet(res.survivorsEnRegistro, setSurvivorsEnRegistro, 'survivors_en_registro');
          checkAndSet(res.survivorsActivos, setSurvivorsActivos, 'survivors_activos');
          checkAndSet(res.totalJugadores, setTotalJugadores);
          checkAndSet(res.survivorsInfo, setSurvivorsInfo);
          checkAndSet(res.survivorsFinalizados, setSurvivorsFinalizados, 'survivors_finalizados');
          checkAndSet(res.seleccionesHechas, setSeleccionesHechas, 'selecciones_hechas');
        } else {
          console.warn('Respuesta vacía o malformada');
        }
      } catch (error) {
        console.error('Error al cargar dashboard:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);


  return (

    <div>

      {/*encabezados */}
      <div className="row">
        {/*SURVIVORS EN REGISTRO */}
        <Card1 survivorsEnRegistro={survivorsEnRegistro} loading={loading}
        />
        {/*SURVIVORS EN LIVE */}
        <Card2 survivorsActivos={survivorsActivos} loading={loading}
        />
        {/*USUARIOS REGISTRADOS */}
        <Card3 usuariosRegistrados={registeredUsers} loading={loading}></Card3>
        {/*USUARIOS VIVOS */}
        <Card4 usuariosVivos={usuariosVivos} loading={loading}></Card4>


      </div>
      {/*fin encabezados */}

      {/* Contenedor principal de la tabla Survivors */}
      <div className="row">
        <div className="col-md-7 mb-4">
          <div className="card shadow h-100">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Survivors</h6>
            </div>
            <div className="card-body scrollable-table">
              <Tables data={survivorsInfo} />
            </div>
          </div>
        </div>

        {/* Card con la gráfica Usuarios por Survivor */}
        <div className="col-md-5 mb-4">
          <div className="card shadow h-100">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-primary">Usuarios por Survivor</h6>

            </div>
            <div className="card-body">
              <Chart1 loading={loading} totalJugadores={totalJugadores} />
            </div>
          </div>
        </div>


      </div>

      {/* Contenedor graficas y cards */}
      <div className="row">
        {/* Gráfica 1 Porcentaje de Usuarios */}
        <div className="col-md-4 mb-4">
          <div className="card shadow h-100">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Porcentaje de Usuarios</h6>
            </div>
            <div className="card-body d-flex align-items-center justify-content-center">
              {
                loading ? <Skeleton height={300} /> : <Chart3 resgistered={registeredUsers} actives={usuariosVivos}></Chart3>
              }
            </div>
          </div>
        </div>

        {/* Gráfica 2  Top 3 de Equipos Seleccionados*/}
        <div className="col-md-4 mb-4">
          <div className="card shadow h-100">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Top 3 de Equipos Seleccionados</h6>
            </div>
            <div className="card-body d-flex align-items-center justify-content-center">
              <Chart2 top3Equipos={top3Equipos} loading={loading} />
            </div>
          </div>
        </div>

        {/* StatCards uno debajo del otro, misma altura total */}
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-between">
          <div className="mb-4 flex-fill">
            <div className="h-100">
              {/*SELECCIONES REALIZADAS*/}
              <Card5
                seleccionesHechas={seleccionesHechas}
              />
            </div>
          </div>
          <div className="flex-fill">
            <div className="h-100">
              {/*SURVIVORS FINALIZADOS*/}
              <Card6
                survivorsFinalizados={survivorsFinalizados}
              />
            </div>
          </div>
        </div>
      </div>


    </div>

  );
}
